// src/components/forms/shared/DangerZoneRow.tsx

import React, { useState } from 'react';
import { Box, Collapse, Typography, useTheme } from '@mui/material';
import { DeleteFormButton } from '../../common/Buttons';
import {
  FormFieldRow,
  FieldLabelContainer,
  FieldLabel,
  FieldInputContainer,
  SimpleSpacerRow,
  FieldInputHeader,
} from './FormElements';
import { SpacerRow } from '../shared/SpacerRow';
import { colors } from '../../../theme/theme';

interface DangerZoneRowProps {
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

const DangerZoneRow: React.FC<DangerZoneRowProps> = ({
  label,
  onClick,
  disabled = false,
}) => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  return (
    <>
      <SimpleSpacerRow height="1.5rem" />
      <SpacerRow
        height="2rem"
        labelHeightMobile="1rem"
        valueHeightMobile="1rem"
        labelBorderMobile={{
          top: 'none',
          bottom: 'none',
        }}
        valueBorder={{
          top: `3px dashed ${theme.palette.dividerContrast}`,
          bottom: 'none',
        }}
        valueBorderMobile={{
          top: `3px dashed ${theme.palette.dividerContrast}`,
          bottom: 'none',
        }}
        labelBackgroundColor={
          theme.palette.mode === 'dark'
            ? theme.palette.grey[750]
            : theme.palette.grey[400]
        }
        labelBackgroundColorMobile={
          theme.palette.mode === 'dark'
            ? theme.palette.grey[750]
            : theme.palette.grey[300]
        }
      />

      {/* Toggle text in proper form row structure */}
      <FormFieldRow>
        <FieldLabelContainer />
        <FieldInputContainer>
          <Box sx={{ width: '100%', maxWidth: '800px' }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                pb: '0.4rem',
              }}
            >
              <Typography
                onClick={() => setOpen(!open)}
                sx={{
                  color: 'primary.main',
                  fontSize: '1.8rem',
                  fontWeight: 500,
                  cursor: 'pointer',
                  '&:hover': {
                    textDecoration: 'underline',
                    color: 'secondary.main',
                  },
                }}
              >
                {open ? 'Hide Delete' : 'Show Delete'}
              </Typography>
            </Box>
          </Box>
        </FieldInputContainer>
      </FormFieldRow>

      <Collapse in={open} sx={{ width: '100%' }}>
        <FormFieldRow>
          <FieldLabelContainer />
          <FieldInputContainer
            sx={{
              maxWidth: '800px',
              [theme.breakpoints.down('sm')]: {
                padding: '0.15rem 0',
              },
            }}
          >
            <FieldInputHeader
              sx={{
                backgroundColor: `${theme.palette.primary.main}`,
                padding: '0.125rem 1rem 0.125rem 0',
                [theme.breakpoints.down('sm')]: {
                  padding: '0.125rem 0',
                },
              }}
            >
              <FieldLabel
                sx={{
                  fontSize: '2rem',
                  fontWeight: '700',
                  paddingLeft: '1rem',
                  color: colors.text.light,
                  [theme.breakpoints.down('sm')]: {
                    paddingLeft: '1rem',
                  },
                }}
              >
                Danger Zone
              </FieldLabel>
            </FieldInputHeader>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                pt: '1rem',
                pb: '0.4rem',
                '@media (max-width: 600px)': {
                  justifyContent: 'center',
                },
              }}
            >
              <DeleteFormButton
                text={label}
                onClick={onClick}
                disabled={disabled}
              />
            </Box>
          </FieldInputContainer>
        </FormFieldRow>
      </Collapse>
    </>
  );
};

export default DangerZoneRow;
